import { Directive, ElementRef, HostListener, inject } from '@angular/core'

/**
 * Erlaubt nur Zahlen in einem Input Feld (0-9)
 *
 *
 * @example
 * <input libNumberOnly>
 */
@Directive({
  selector: '[libNumberOnly]',
})
export class NumberOnlyDirective {
  private el = inject(ElementRef)

  @HostListener('input', ['$event'])
  onPaste(event: Event) {
    let value = (event.target as HTMLInputElement).value
    value = value.replace(/[^0-9]/g, '')
    this.el.nativeElement.value = value
  }
}
